var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.getTag,_vm._b({tag:"component",staticClass:"footer-logos__logo"},'component',_vm.getAttrs,false),[(_vm.logo.image)?_c('img',{attrs:{"src":_vm.logo.image,"loading":"lazy","alt":'Logo' + _vm.logo.id}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }